var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex items-center justify-center border border-secondary3 rounded relative text-sm",
      staticStyle: { height: "46px" }
    },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "absolute bg-white text-xs font-medium px-1",
              class: _vm.bglabel,
              staticStyle: { top: "-0.625rem", left: "0.5rem" },
              attrs: { for: _vm.name }
            },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.value.color
        ? _c("div", {
            staticClass: "rounded-full ml-3",
            style:
              "height: 1.25rem; width: 1.25rem; background:" + _vm.value.color
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-select", {
        staticClass:
          "custom-select font-medium w-full bg-transparent border-0 pr-2 pt-1 rounded focus:outline-none",
        staticStyle: { "padding-left": "2px", "text-transform": "capitalize" },
        attrs: {
          id: _vm.name,
          name: _vm.name,
          options: _vm.options,
          placeholder: _vm.placeholder,
          components: {
            OpenIndicator: _vm.OpenIndicator,
            Deselect: _vm.Deselect
          },
          disabled: _vm.disabled
        },
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04350d06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04350d06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomSelect.vue
// module id = null
// module chunks = 